import { HStack, Text, Button, Card, CardHeader, CardBody, Icon } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { FaAsterisk } from 'react-icons/fa';
import SignatureCanvas from 'react-signature-canvas';


export default function Signature({ onSignature, clearSignaturOnSubmitForm }) {

    const sigCanvas = useRef(null);
    const [history, setHistory] = useState([]);
    const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 });

    const fillCanvasBackground = () => {
        const canvas = sigCanvas.current.getCanvas();
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = "#FFFACD";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    };

    const saveToHistory = () => {
        const canvas = sigCanvas.current.getCanvas();
        const signatureData = canvas.toDataURL();
        setHistory([...history, signatureData]);
    };

    const clearSignature = (e) => {
        if (e) e.preventDefault();
        sigCanvas.current.clear();
        onSignature(null);
        fillCanvasBackground();
        saveToHistory(); // Save the initial state to history
    };

    const handleSignatureEnd = (e) => {
        e.preventDefault();
        const signatureData = sigCanvas.current.toDataURL();
        if (signatureData) {
            onSignature(signatureData);
        }
        saveToHistory(); // Save the latest state to history
    };

    const undoLastStroke = () => {
        if (history.length === 0) return;

        const newHistory = history.slice(0, -1); // Remove the last element
        setHistory(newHistory);

        if (newHistory.length === 0) {
            // Clear the canvas if history is empty
            sigCanvas.current.clear();
            fillCanvasBackground();
        } else {
            // Restore the last saved state
            const lastState = newHistory[newHistory.length - 1];
            const canvas = sigCanvas.current.getCanvas();
            const ctx = canvas.getContext('2d');
            const img = new Image();
            img.src = lastState;
            img.onload = () => {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(img, 0, 0);
            };
        }
    };

    const handleResize = () => {
        const maxWidth = 653;
        const maxHeight = 187;
        const width = Math.min(window.innerWidth * 0.8, maxWidth); // Adjust width as needed, up to maxWidth
        const height = (width / maxWidth) * maxHeight; // Maintain aspect ratio
        setCanvasSize({ width, height });
    };

    useEffect(() => {
        fillCanvasBackground();
        handleResize(); // Set initial size
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        // Ensure canvas background is filled when size changes
        fillCanvasBackground();
    }, [canvasSize]);

    useEffect(() => {  //clear signature after form submitted
        if (clearSignaturOnSubmitForm)
            clearSignature();
    }, [clearSignaturOnSubmitForm])

    return (
        <Card
            border={"1px solid #ddd"}
            boxShadow={"none"}
            borderRadius={"4px"}

        >
            <CardHeader
                bgColor="primary.bgGrey"
                borderBottom="1px solid"
                borderColor="primary.borderGrey"
                borderTopLeftRadius="3px"
                borderTopRightRadius="3px"
                p="10px 15px"
            >
                <Text variant={"runningText"} fontSize={"16px"}>
                    <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />{" "}
                    חתימה - {" "}
                    <Text as="span" color={"primary.error"} fontWeight={"bold"}>נא לחתום באזור הצהוב</Text>
                </Text>
            </CardHeader>
            <CardBody p="15px">
                <SignatureCanvas
                    ref={sigCanvas}
                    onEnd={handleSignatureEnd}
                    canvasProps={{
                        width: canvasSize.width,
                        height: canvasSize.height,
                    }}
                />
                <HStack gap="2px" pt="10px">
                    <Button
                        p="0"
                        h="auto"
                        fontSize={"14px"}
                        onClick={clearSignature}
                        aria-label="נקה חתימה"

                    >נקה
                    </Button>
                    <Button
                        p="0"
                        h="auto"
                        fontSize={"14px"}
                        onClick={undoLastStroke}
                        aria-label="חזור"
                    >חזור
                    </Button>
                </HStack>
            </CardBody>
        </Card>
    )
}